import { FC } from 'react';

const RoubleIcon: FC<{ className?: string }> = ({ className }) => {
	return <span className={className}>₽</span>;
};

export default RoubleIcon;
